// scripts inside this function will be executed immediately before the stencil components are loaded
// https://stenciljs.com/docs/config#globalscript
export default () => {
    window.addEventListener('appload', () => {
        document.documentElement.classList.add('hydrated');
    });
};
